module.exports = __webpack_public_path__ + "img/solar_download-outline.af3a81d8.svg";